export default __webpack_public_path__ + "static/media/app_covid_uy.03a28b1c.png";